import { render, staticRenderFns } from "./ClientSelect.vue?vue&type=template&id=37cef522&"
import script from "./ClientSelect.vue?vue&type=script&lang=js&"
export * from "./ClientSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/piscinaFacilDev/piscinapp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37cef522')) {
      api.createRecord('37cef522', component.options)
    } else {
      api.reload('37cef522', component.options)
    }
    module.hot.accept("./ClientSelect.vue?vue&type=template&id=37cef522&", function () {
      api.rerender('37cef522', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/selects/ClientSelect.vue"
export default component.exports